    (function() {
  'use strict';

  angular
    .module('admin.users.details.wallets.service', [])
    .factory('WalletsService', WalletsService);

  /** @ngInject */
  function WalletsService($http, $q, API) {
    function getWallet(userId) {
      var defer = $q.defer();

      $http
        .get(API.API_URL + "admin/users/" + userId + "/cash/stats")
        .success(defer.resolve)
        .error(defer.reject);

      return defer.promise;
    }

    return{
      getWallet: getWallet
    };

  }

})();
